import { useNavigate } from "react-router-dom"
import type React from "react"
import type { PostSimpleResponse } from "@/types/domain"
import { FaRegHeart, FaRegComment, FaRegEye } from "react-icons/fa"
import { Tag } from "@/components/ui"
import "./PostItem.css"

type PostItemProps = {
  post: PostSimpleResponse
  tagMap?: Record<string, string>
}

export const PostItem: React.FC<PostItemProps> = ({ post, tagMap }) => {
  const navigate = useNavigate()
  // Determine variant based on data
  // Variant is primarily determined by whether there is a thumbnail
  const hasThumbnail = !!post.thumbnailUrl

  const handleClick = () => {
    navigate(`/community/${post.id}`)
  }

  return (
    <div className="post-item-container" onClick={handleClick} style={{ cursor: "pointer" }}>
      <div className="post-item-content">
        <div className="post-item-header">
            {/* Location or Special Tag Badge could go here if available in expanded data */}
             {post.tags && post.tags.length > 0 && (
                 <div className="post-item-tags">
                     {post.tags.slice(0, 1).map((tag, index) => (
                         <Tag key={index} variant="default">
                           {tagMap ? (tagMap[tag] || tag) : tag}
                         </Tag>
                     ))}
                 </div>
             )}
          <h3 className="post-item-title">{post.title}</h3>
          <p className="post-item-board">{post.boardName} · {post.authorNickname}</p>
        </div>
        
        <div className="post-item-meta">
            <span className="post-meta-item">
                <span className="post-meta-date">{new Date(post.createdAt).toLocaleDateString()}</span>
            </span>
            <div className="post-meta-stats">
                <span className="post-meta-item">
                    <FaRegEye /> {post.viewCount}
                </span>
                <span className="post-meta-item">
                    <FaRegHeart /> {post.likeCount}
                </span>
                <span className="post-meta-item">
                    <FaRegComment /> {post.commentCount}
                </span>
            </div>
        </div>
      </div>

      {hasThumbnail && (
        <div className="post-item-thumbnail">
          <img src={post.thumbnailUrl} alt={post.title} loading="lazy" />
        </div>
      )}
    </div>
  )
}
